<template>
  <div v-if="headerStore.showMenu">
    <div class="grid grid-cols-3 bg-white border-gray-200 shadow-sm  dark:bg-gray-700 dark:border-gray-600 mega-menu menu-shadow ">
      <div v-if="menuData.style.left !== 'white'" :class="['bg-' + menuData.style.left + '-50']"></div>
      <div v-else></div>
      <div class="w-screen xl:max-w-screen-xl lg:max-w-screen-lg md:max-w-screen-md">
        <div class="grid grid-flow-row-dense mx-auto auto-cols-fr" :class="['grid-cols-4 md:grid-cols-' + menuData.cols]">
          <section
            v-for="(column, index) in menuData.columns"
            :key="index"
            class="w-full md:mt-0 py-4 md:py-8"
            :class="[
              'bg-' + column.style.background + '-50 col-span-4 md:col-span-' + column.size,
              (index === 0 ? 'md:pl-8 md:pr-3' : ''),
              (index === (menuData.columns.length - 1) ? 'md:pr-8 pb-0' : 'pb-0')
            ]"
          >
            <ul class="md:block grow h-full pb-6 md:pb-0 gap-0 md:gap-2 space-y-2 px-0 md:px-4">
              <div v-if="column.title" class="column-title pb-1 md:pb-1 px-4 md:px-0">
                <div class="hidden md:flex justify-between items-center font-semibold text-sm text-primary-600 leading-5">
                  {{column.title}}
                </div>
                <div
                  class="flex md:hidden justify-between items-center font-semibold text-sm text-primary-600 leading-5"
                >
                  {{column.title}}
                </div>
              </div>
              <Transition name="slide-fade">
                <div v-if="column.visible">
                  <li v-for="(item, index) in column.items" :key="index">
                    <div v-if="item.type === 'Link'">
                      <MenuItem :item="item" />
                    </div>
                    <div v-else-if="item.type === 'Icon en link'">
                      <IconCard :card="item" />
                    </div>
                    <div v-else-if="item.type === 'Afbeelding en link'">
                      <ImageCard :card="item" />
                    </div>
                    <div v-else-if="item.type === 'Text'">
                      <TextCard :item="item" />
                    </div>
                  </li>
                </div>
              </Transition>
            </ul>
          </section>
        </div>
      </div>
      <div :class="['bg-' + menuData.style.right + '-50']"></div>
    </div>
  </div>
</template>

<script setup>
import ImageCard from './ImageCard.vue'
import IconCard from './IconCard.vue'
import MenuItem from './MenuItem.vue'
import TextCard from './TextCard.vue'
import { useHeaderStore } from '@/stores'
import { ref, watch } from 'vue'

const headerStore = useHeaderStore()

const menuData = ref(headerStore.menus[0])

watch(() => headerStore.selectedButton, (a, b) => {
  if (a !== null) {
    // console.log(headerStore.menus);
    for (let i = 0; i < headerStore.menus.length; i++) {
      if (headerStore.menus[i].label === headerStore.selectedMenu) {
        menuData.value = headerStore.menus[i]
      }
    }
  }
})
</script>
